export const CALENDAR_MONTHS = [
    { value: 1, transKey: 'DEPOSIT.CALENDAR_MONTHS.JANUARY' },
    { value: 2, transKey: 'DEPOSIT.CALENDAR_MONTHS.FEBRUARY' },
    { value: 3, transKey: 'DEPOSIT.CALENDAR_MONTHS.MARCH' },
    { value: 4, transKey: 'DEPOSIT.CALENDAR_MONTHS.APRIL' },
    { value: 5, transKey: 'DEPOSIT.CALENDAR_MONTHS.MAY' },
    { value: 6, transKey: 'DEPOSIT.CALENDAR_MONTHS.JUNE' },
    { value: 7, transKey: 'DEPOSIT.CALENDAR_MONTHS.JULY' },
    { value: 8, transKey: 'DEPOSIT.CALENDAR_MONTHS.AUGUST' },
    { value: 9, transKey: 'DEPOSIT.CALENDAR_MONTHS.SEPTEMBER' },
    { value: 10, transKey: 'DEPOSIT.CALENDAR_MONTHS.OCTOBER' },
    { value: 11, transKey: 'DEPOSIT.CALENDAR_MONTHS.NOVEMBER' },
    { value: 12, transKey: 'DEPOSIT.CALENDAR_MONTHS.DECEMBER' },
];

export default {
    CALENDAR_MONTHS,
};



// WEBPACK FOOTER //
// ./src/constants/calendarValues.js